export const hasModuleAccess = (user, moduleKey, action = "view") => {
  if (!user) return false;
  if (["admin", "owner"].includes(user.role)) return true;
  let permissions = user.permissions;
  if (typeof permissions === "string") {
    try {
      permissions = JSON.parse(permissions);
    } catch {
      return false;
    }
  }
  return permissions?.[moduleKey]?.[action] === true || permissions?.[moduleKey]?.[action] === 1;
};
